module.exports = __webpack_public_path__ + "img/404.070799e7.png";